module.exports = __webpack_public_path__ + "PERUVIANhome-4.6b5e731b.png";